// Currently, this action is for testing purposes only.
// Thus, action creator is not needed.

const SET_CLOCK_SKEW_ADJUSTMENT = 'WEB_CHAT/SET_CLOCK_SKEW_ADJUSTMENT';

export { SET_CLOCK_SKEW_ADJUSTMENT };
